import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { capitalize, toTitleCase } from '../../utils/stringManipulations';
import I18N from "../../I18N";
import calendar from '../../assets/icons/calendar.svg';
import { GREEN_LIGHT } from '../../styles/colors';

dayjs.extend(utc)
const setDisplayDate = (date, duration) => {
  const today = dayjs();
  const taskDate = dayjs(date);
  const day = today.$D === taskDate.$D && today.$M === taskDate.$M ? capitalize(I18N.t("TODAY")) : taskDate.format('MMM D');
  const time = taskDate.utc().format("hh:mm a");
  // const displayedDuration = `${duration/60}h`;
  // return `${day} | ${time} | ${displayedDuration} |`;
  return `${today.$D === taskDate.$D ? time : day} | `;
}

const ScheduleRow = ({ onClick, task }) => {
  const { duration, startTime, team: { name } = {} } = task || null;
  const displayDate = setDisplayDate(startTime, duration);
  
  return (
    <div className="single-site__info__schedule" data-testid="schedule-row">
      <div style={{ display: "flex", alignItems: "center" }}>
        <img className="single-site__info__schedule__icon" src={calendar} alt=""/>
        {Object.values(task).length > 0 ?
          <div className="single-site__info__schedule__next-recording">
            <span style={{ color: GREEN_LIGHT }}>{`${toTitleCase(I18N.t("NEXT_RECORDING"))}: `}</span>
            <span className="single-site__info__schedule__next-recording__highlighted">{displayDate}</span>
            <span className="single-site__info__schedule__next-recording__highlighted">{name}</span>
          </div> :
          <span>{capitalize(I18N.t("NO_RECORDINGS_SCHEDULED"))}</span>
        }
      </div>
      <button className="single-site__info__schedule__button" onClick={onClick} data-testid="see-all">
        <span>{I18N.t("SEE_ALL")}</span>
      </button>    
    </div>
  );
};

ScheduleRow.propTypes = {
  onClick: PropTypes.func, 
  task: PropTypes.object 
};

ScheduleRow.defaultProps = {
  onClick: ()=> {}, 
  task: {}
};

export default ScheduleRow;
